import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.css"; // Importing the CSS file

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left Side: Logo & Company Name */}
        <div className="navbar-logo">
          <img src="https://cdn.vectorstock.com/i/1000x1000/67/96/mvm-logo-letter-design-vector-41346796.webp" alt="Logo" className="logo" />
          <span className="company-name">Company Name</span>
        </div>

        {/* Hamburger Icon */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        {/* Right Side: Navigation Links */}
        <div className={`navbar-links ${menuOpen ? "active" : ""}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/casestudy" className="nav-link" onClick={() => setMenuOpen(false)}>Case Study</Link>
          <Link to="/services" className="nav-link" onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
